// Angular
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

// Models
import { Job } from '../../models';
import { JobCommentChannelDto } from '../../models/job-comment-channel-dto';
import { JobCommentDto } from '../../models/job-comment-dto';
import { AppCleanup } from '../../../../shared/models';
import { JobTypeChannelDto } from '../daily-report/models/job-type-channel-dto';

// Services
import { JobService } from '../../services/job.service';

// Helpers
import { UtilityHelper } from '../../../../shared/helpers';

@Component({
	selector: 'comment-log-tooltip',
	templateUrl: './comment-log-tooltip.component.html',
	styleUrls: ['./comment-log-tooltip.component.scss'],
})
export class CommentLogTooltipComponent extends AppCleanup implements OnInit, OnDestroy {
	@Input() job: Job;
	@Input() key: string;
	@Input() jobComment: JobCommentDto;

	/**
	 * Job Comment Channels to show. Values that are NULL will be excluded. Values that are 0 will be included.
	 * These values come from the Job Comment, which takes a Snapshot of Job Comments from the time they were added.
	 */
	jobCommentChannels: JobCommentChannelDto[] = [];
	constructor(private jobService: JobService) {
		super();
	}

	ngOnInit() {
		this.jobCommentChannels = UtilityHelper.deepCopy(this.jobComment.jobCommentChannels.filter((jcc) => jcc.value !== null));
		this.roundChannelsForPrecision();
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	private roundChannelsForPrecision() {
		this.jobCommentChannels.forEach((jcc) => {
			if (jcc.jobTypeChannel?.channel) {
				jcc.value = +jcc.value.toFixed(jcc.jobTypeChannel?.channel.precision);
			}
		});
	}

	public getHexColorForChannel(jobTypeChannel: JobTypeChannelDto): string {
		if (this.job && jobTypeChannel?.channelId) {
			let userJobChannel = this.jobService.findUserUnitPeriodChannelsForJob(this.job.key).find((ujc) => ujc.unitPeriodChannel.channelId === jobTypeChannel?.channelId);

			if (userJobChannel?.colorHex) {
				return userJobChannel.colorHex;
			}
		}

		return 'black';
	}
}
